export default "__VITE_ASSET__Iq7p$NM4__"